import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../irtiza-dynamic-input/irtiza-dynamic-main-inputs';

const AccessoryInfoAdd = (props) => {
  
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};
  
  const [inputProps, setInputProps] = useState({
  
    AccessoryID:{name: 'AccessoryID',   value: props.AccessoryID || '' ,enabled:false},

    AccessoryType:{
      name:{id:'AccessoryTypeID',value:'AccessoryType'},
      caption: 'Select Accessory Type',
      value: {id: props.AccessoryTypeID || undefined ,value:props.AccessoryType || ''},
      dataSource: {type:'Route',route:'AccessoryTypeInfo'},
        },

    Color:{
      name:{id:'ColorID',value:'Color'},
      caption: 'Select Color',
      value: {id: props.ColorID || undefined ,value:props.Color || ''},
      dataSource: {type:'Route',route:'ColorInfo'},
        },

    AccessoryName:{name: 'AccessoryName',   value: props.AccessoryName || '' },


    Unit:{
      name:{id:'UnitID',value:'Unit'},
      caption: 'Select Unit',
      value: {id: props.UnitID || undefined ,value:props.Unit || ''},
      dataSource: {type:'Route',route:'UnitInfo'},
        },


        });
// EXTRA CODE START

// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {
  
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
 
  let inputsList = [
    {Input: HiddenComponent ,Props: {...inputProps.AccessoryID, setInputProps },ColumnSize:0},
    {Input: DropdownComponent,Props: {...inputProps.AccessoryType, setInputProps },ColumnSize:6},
    {Input: DropdownComponent,Props: {...inputProps.Color, setInputProps },ColumnSize:6},
    {Input: TextComponent,Props: {...inputProps.AccessoryName,setInputProps },ColumnSize:6},
    {Input: DropdownComponent,Props: {...inputProps.Unit, setInputProps },ColumnSize:6},
    ];
  return (
    <div onKeyDown={(e)=>e.stopPropagation()}>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={props} title={`Accessory ${props.isAdd == true ? `Add` : `Edit`}`} Inputs={inputsList}/>
      {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}
      </div>
  );
}; 

export default AccessoryInfoAdd;
